import { render, staticRenderFns } from "./reschedule.vue?vue&type=template&id=c2596f50&"
import script from "./reschedule.vue?vue&type=script&lang=js&"
export * from "./reschedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports